export default "__VITE_ASSET__Bs6S$CKp__"